import React from "react";
import styles from "./MenuBar.module.css";
import homeIcon from "../../images/logo-white.svg";
import searchIcon from "../../images/search.svg";
import profileIcon from "../../images/user-white.svg";
import walletIcon from "../../images/wallet-white.svg";
import settingsIcon from "../../images/settings.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  toggleMenuBar,
  showSearchWindow,
  showWalletMenuBar,
  hideWalletMenuBar,
} from "../../store/actions";
import SingleLine from "./SingleLine";
import ToggleLine from "./ToggleLine";
import WalletSection from "./WalletSection";
import { checkCookie } from "../Common";

const MenuBar = () => {
  const dispatch = useDispatch();
  const menuBarToggle = useSelector((state) => state.menuBarToggle);
  const walletMenuBar = useSelector((state) => state.walletMenuBar);
  const loggedUser = useSelector((state) => state.loggedUser);

  return (
    <aside
      className={`${styles.sidebar} ${menuBarToggle ? styles.active : null} `}
    >
      <div>
        <ToggleLine
          onClick={() => {
            dispatch(toggleMenuBar());
            dispatch(hideWalletMenuBar());
          }}
        />
        <SingleLine icon={homeIcon} heading="Home" link="/" />
        <SingleLine
          icon={searchIcon}
          heading="Search"
          onClick={() => dispatch(showSearchWindow())}
        />
        {checkCookie("active_user") ? (
          <SingleLine icon={profileIcon} heading="Profile" link="/my-account" />
        ) : (
          <SingleLine
            icon={profileIcon}
            heading="Profile"
            data-bs-toggle="modal"
            data-bs-target="#loginmodal"
          />
        )}
        <SingleLine
          icon={walletIcon}
          heading="Wallet"
          onClick={() => {
            if (loggedUser.name === "") {
              alert("Login First");
              return;
            }
            walletMenuBar
              ? dispatch(hideWalletMenuBar())
              : dispatch(showWalletMenuBar());
          }}
        />
        {walletMenuBar ? <WalletSection /> : null}
      </div>
      <div>
        {/* <SingleLine icon={settingsIcon} heading="Settings" link="/" /> */}
      </div>
    </aside>
  );
};

export default MenuBar;
